import Box from 'components/Box'
import Text from 'components/Text'
import { PopOverItem } from 'components/PopOver/types'

import { MoreOptionsPopOver } from 'components'

type Props<T> = {
  badge?: JSX.Element
  menuOptions?: PopOverItem[]
  onClickOption?: (value: T) => void
  showMenu?: boolean
  title: string
}

const PanelTitle = <T extends string>({ badge, menuOptions, onClickOption, showMenu, title }: Props<T>) => {
  const handleSelect = (value?: PopOverItem) => {
    value && onClickOption?.(value.value as T)
  }

  return (
    <Box alignItems="center" display="flex" justifyContent="space-between">
      <Text fontSize={16} fontWeight="bold" lineHeight="24px">
        {title}
      </Text>
      <Box alignItems="center" display="flex" justifyContent="flex-end">
        {badge}
        {menuOptions && (
          <MoreOptionsPopOver
            isVisible={showMenu}
            ml="8px"
            options={menuOptions}
            onSelect={handleSelect}
            showTargetBorder={false}
          />
        )}
      </Box>
    </Box>
  )
}

export default PanelTitle
